// extracted by mini-css-extract-plugin
export default {"header":"MyActTeam_header__HZ6Vn","tabsWrapper":"MyActTeam_tabsWrapper__-+iPI"};